import './style.css';

export function NavigationAbout() {
  return (
    <div className="about_bg">
      <div className="about_container">
        <nav className="about_container_nav">
          <ul className="list_nav_about">
            <li>
              <a href="https://slt.ifsp.edu.br/index.php/como-chegar">
                como chegar
              </a>
            </li>
            <li>
              <a href="https://slt.ifsp.edu.br/index.php/contato">contato</a>
            </li>
            <li>
              <a href="https://slt.ifsp.edu.br/index.php/estrutura-e-direcao">
                estrutura e setores
              </a>
            </li>
            <li>
              <a href="https://slt.ifsp.edu.br/index.php/funcionamento">
                funcionamento
              </a>
            </li>
            <li>
              <a href="https://slt.ifsp.edu.br/index.php/historico">
                histórico
              </a>
            </li>
            <li>
              <a href="https://www.ifsp.edu.br/component/content/article/59-acesso-a-informacao/69-acessoainformacao">
                acesso à informação
              </a>
            </li>
            <li>
              <a href="https://www.ifsp.edu.br/component/content/article/81">
                ouvidoria
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
